import DisciplineRecord from '../models/discipline-record.model';
import { ApiResponse } from '../models/api/api-response.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API } from '../constants/api';

@Injectable({ providedIn: 'root' })
export class DisciplineRecordService {
  private http: HttpClient = inject(HttpClient);

  getDisciplineRecordsListing(p: {
    page?: number;
    limit?: number;
    schoolYear?: string;
    types?: string[];
    authorId?: string;
    userId?: string;
  }) {
    let params = new HttpParams();
    if (p.page) params = params.set('page', p.page);
    if (p.limit) params = params.set('limit', p.limit);
    if (p.schoolYear) params = params.set('y', p.schoolYear.trim());
    if (p.authorId) params = params.set('authorId', p.authorId.trim());
    if (p.userId) params = params.set('userId', p.userId.trim());
    if (p.types) {
      params = params.set('types', p.types.join(',').toLowerCase().trim());
    }

    return this.http.get<ApiResponse<DisciplineRecord[]>>(
      API.disciplineRecordListing(),
      { withCredentials: true, params }
    );
  }

  postDisciplineRecord(data: any) {
    return this.http.post<ApiResponse<DisciplineRecord>>(
      API.disciplineRecord(),
      data,
      { withCredentials: true }
    );
  }

  deleteDisciplineRecord(id: string) {
    return this.http.delete<ApiResponse<any>>(API.disciplineRecord(id), {
      withCredentials: true,
    });
  }
}
